import { combineReducers } from 'redux';
import { ERROR, RESET, START, SUCCESS } from './constants';

const isFetching = (state = false, { type }) => {
  switch (type) {
    case START:
      return true;
    case SUCCESS:
    case ERROR:
      return false;
    default:
      return state;
  }
};

const response = (state = {}, { type, payload }) => {
  switch (type) {
    case RESET:
    case ERROR:
      return {};
    case SUCCESS:
      return payload || {};
    default:
      return state;
  }
};

const validated = combineReducers({
  isFetching,
  response,
});

export default validated;
